import { FormObjType } from "DataTypes/Form";

export const AddEditForm: FormObjType[] = [
  {
    id: "input-substance-name",
    label: "Substance Name",
    placeholder: "Enter Substance Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "date-start-date",
    label: "Start Date",
    placeholder: "Select Start Date",
    boxType: "date",
    boxSize: 4,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "date-end-date",
    label: "End Date",
    placeholder: "Select End Date",
    boxType: "date",
    boxSize: 4,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
  }
]